import { StylesProcessorLexer } from "./StylesProcessorLexer"; 

export class StylesProcessor
{
  static convert( styles:string )
  {
    let lexer = new StylesProcessorLexer();
    return lexer.convert( styles );
  }

}